<template>
  <v-container fluid class="panel" v-if="parking !== null">
    <v-layout row wrap>
      <v-flex xs11>
        <v-text-field append-icon="search" label="" single-line :placeholder="$t('private_global.filter')" hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs1 text-xs-right>
        <v-btn color="primary" fab flat @click="loadData">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-data-table :headers="headers" :items="spots" :rows-per-page-text="$t('global_tables_rows_page')" :rows-per-page-items="rowsPerPageItems" :search="search">
          <template slot="items" slot-scope="props">
            <td width="50%">{{ props.item.label }}</td>
            <td>
              <v-chip :color="props.item.statusClass" outline>{{ props.item.statusText }}</v-chip>
            </td>
          </template>
          <template slot="no-data">
            <v-alert :value="true" outline color="info" v-html="$t('private_dash_table_earnings_nodata')"> </v-alert>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} {{ $t('global_table_from_of_preposition') }} {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { EventBus } from '@/services/eventBus';
import spotService from '@/services/spotService';
import keys from '@/store/keys';
import _ from 'lodash';

export default {
  name: 'parking-spots-table-box',
  props: ['parkingId'],
  data() {
    return {
      rowsPerPageItems: [25, 50, 100, { text: this.$i18n.t('row_pagination_all'), value: -1 }],
      spotsAmount: 0,
      spots: [],
      spotsFromData: [],
      search: [],
      headers: [
        {
          i18nText: 'private_parking_activity_spots_spots_name',
          text: this.$i18n.t('private_parking_activity_spots_spots_name'),
          align: 'left',
          value: 'label'
        },
        {
          i18nText: 'private_parking_activity_spots_spots_status',
          text: this.$i18n.t('private_parking_activity_spots_spots_status'),
          align: 'left',
          value: 'statusText'
        }
      ]
    };
  },
  created() {
    EventBus.$on(keys.eventOnLanguageChanged, this.updateTableLables);
    this.loadData();
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateTableLables);
  },
  methods: {
    updateTableLables() {
      this.updateSpotStatusText();
    },
    loadData() {
      let params = {
        parking: this.parkingId
      };
      spotService.list(params, this.listSuccessHandler, this.listErrorHandler);
    },
    listSuccessHandler(data) {
      this.spotsFromData = [];
      if (data.spots) {
        this.spotsFromData = data.spots;
        this.updateSpotStatusText();
      } else {
        this.spotsAmount = data.total;
      }
    },
    listErrorHandler() {},
    updateSpotStatusText() {
      _.each(this.headers, itHeader => {
        itHeader.text = this.$i18n.t(itHeader.i18nText);
      });
      this.spots = [];
      this.$nextTick(() => {
        if (this.$i18n !== null) {
          this.spots = this.spotsFromData;
          _.each(this.spots, spot => {
            switch (spot.status) {
              case 'AVAILABLE':
              case 'FREE':
                spot.statusClass = 'green';
                spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_1');
                break;
              case 'RESERVED':
                spot.statusClass = 'green';
                spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_2');
                break;
              case 'IN_USE':
                spot.statusClass = 'green';
                spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_3');
                break;
              case 'WRONG':
                spot.statusClass = 'green';
                spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_4');
                break;
              case 'NO_AVAILABLE_FREE':
                spot.statusClass = 'red';
                spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_5');
                break;
              case 'NO_AVAILABLE_OCCUPIED':
                spot.statusClass = 'red';
                spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_6');
                break;
              case 'BROKEN':
                spot.statusClass = 'red';
                spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_7');
                break;
              case 'OCCUPIED':
                spot.statusClass = 'red';
                spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_8');
                break;
              default:
                spot.statusClass = 'red';
                spot.statusText = '-';
                break;
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
h1.table-title,
.panel .panel-heading .panel-title {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/ParkingSpotsTableBox.vue